import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import MyTable, { TableRow } from "../../../components/MyTable";
import { resetContractsSort, searchEmployeeContracts, setContractsSort, setContractObservation as setContractObservationResult } from "../../../store/slices/documents";
import { TableHeadRows } from "../../../components/MyTable/TableHead";
import DownloadButtonDocument from "./downloadButtonDocument";
import { CONTRACT_DOCUMENT_SIGNATURE_REQUEST, EMPLOYEE_CONTRACTS_ONE, EMPLOYEE_CONTRACTS_THREE, EMPLOYEE_CONTRACTS_TWO } from "../../../constants/signalRequestConsts";
import { useEffect, useState } from "react";
import { Button, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { setContractObservation } from "../../../api/signalApi";
import EditNoteIcon from '@mui/icons-material/EditNote';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { formatDateToTimestamp } from "../../../utils/date";
import MySnackbar from "../../../components/MySnackbar";
import { EmployeContracts } from "../../../interfaces/employeeDocuments.interface";

interface TableContractsProps {
    numberOfCards?: number;
    changeViewOptionHidden?: boolean;
    startDate?: Date;
    endDate?: Date;
    requestId: (typeof EMPLOYEE_CONTRACTS_ONE | typeof EMPLOYEE_CONTRACTS_TWO |  typeof EMPLOYEE_CONTRACTS_THREE)

    status?: 0 | 1 | 2;

    hiddenBottomPaginator?: boolean;
    hiddenFilterOptions?: boolean;
}

const TableContracts = ({requestId, hiddenFilterOptions, ...props}: TableContractsProps) => {
    const documents = useSelector((state: RootState) => state.documents[requestId]);
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch<AppDispatch>();
    const [contractToObservate, setContractToObservate] = useState<any>();
    const [observation, setObservation] = useState<string>("");
    const [filterState, setFilterState] = useState<string>("all");
    const [observationResult, setObservationResult] = useState<{success: boolean, msg: string} | null>(null);
    const [startDate, setStartDate] = useState<Date | null>(props.startDate || null);
    const [endDate, setEndDate] = useState<Date | null>(props.endDate || null);
    const [finalItems, setFinalItems] = useState<EmployeContracts[]>([]);

    const employeeContractsTableHeadRows = [
        {
            label: "Empresa",
            rowKeyName: "Empresa",
            allowOrderAction: true,
        },{
            label: "Número",
            rowKeyName: "NumeroContrato",
            allowOrderAction: true,
        },{
            label: "Fecha de inicio",
            rowKeyName: "FechaInicio",
            allowOrderAction: true,
        },{
            label: "Fecha de fin",
            rowKeyName: "FechaFin",
            allowOrderAction: true,
        },{
            label: "Días finalizar",
            rowKeyName: "DiasVencimiento",
            allowOrderAction: true,
        },{
            label: "Tipo contrato",
            rowKeyName: "TipoContrato",
            allowOrderAction: true,
        },{
            label: "Oficina",
            rowKeyName: "Area",
            allowOrderAction: true,
        },{
            label: "Estado",
            rowKeyName: "EstadoAceptacion",
            allowOrderAction: true,
        },{
            label: "Fec. envío",
            rowKeyName: "FechaEnviadoPortal",
            allowOrderAction: true,
        },{
            label: "Fec. firma",
            rowKeyName: "FirmadoFecha",
            allowOrderAction: true,
        },{
            label: "Observación",
            rowKeyName: "FirmadoRespuesta",
            customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
                return <Grid
                    container 
                    justifyContent="space-between" 
                    direction="row"
                    style={{minWidth: row.FirmadoRespuesta ? "11rem" : "7rem"}}
                >
                    <Grid 
                        item 
                        style={{
                            width: row.FirmadoRespuesta ? "9rem" : "3rem", 
                            // whiteSpace: "nowrap", 
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            lineClamp: "2",


                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",

                        }}>
                        {row.FirmadoRespuesta}
                    </Grid>
                    <Grid item alignItems="flex-end">
                        <IconButton
                            size="small"
                            onClick={() => {
                                setObservation(row.FirmadoRespuesta || "")
                                setContractToObservate(row)
                            }}
                        >
                            <EditNoteIcon fontSize="small" />
                        </IconButton>
                    </Grid>
                </Grid>
            }
        },{
            label: "",
            rowKeyName: "viewFile",
            customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
                return (
                <DownloadButtonDocument
                    signButton={true}
                    FirmaTop={row.FirmaTop}
                    FirmaLeft={row.FirmaLeft}
                    FirmaPagePosition={row.FirmaPagina}
                    NroFs={row.NroFS}
                    FirmadoFecha={row.FirmadoFecha} 
                    IdDocument={row.NroIdentificadorContrato}
                    requestId={CONTRACT_DOCUMENT_SIGNATURE_REQUEST}
                    signDisabled={row.FirmadoRespuesta ? true : false}
                    isContract={true}
                />
            )},
        }
    ,];

    useEffect(() => {
        if (!companyselected || !connectionId) {
            return;
        }
        dispatch(resetContractsSort(requestId));
        dispatch(searchEmployeeContracts((props.status || 0), requestId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected, connectionId]);

    
    useEffect(() => {
        const filteredItems = documents.contracts.filter(c => 
            filterState === "all" 
            || c.EstadoAceptacion.toLowerCase() === filterState.toLowerCase()
        );
        setFinalItems(filteredItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documents.contracts, filterState]);

    return (
        <>
        <MyTable
            key="tab-4"
            hiddenFilterOptions={hiddenFilterOptions}
            calculateLimitDate={true}
            hiddenSearchInput={hiddenFilterOptions
                ? true :  false}
            dateFilterField={'FechaEnviadoPortal'}
            tableHeadRows={employeeContractsTableHeadRows}
            tableRows={finalItems}
            setOrderedData={(sortField: any, sortType: any, rowData: any) => dispatch(setContractsSort({sortField, sortType, rowData, requestId}))}
            sortField={documents.contractsSortField}
            sortType={documents.contractsSort}
            loading={documents.contractsLoading}
            selectControlProps={
                hiddenFilterOptions
                ? undefined
                : {
                    label: "Tipo contrato",
                    autocalculateFieldName: "TipoContrato"
                }
            }
            customStartItemOptionBar={() =>
                
                <Grid item > 
                    <FormControl style={{width: "100%"}}>
                        <InputLabel id="select-option-label">Estado</InputLabel>
                        <Select
                            labelId="select-option-label"
                            id="select-option"
                            label="Estado"
                            onChange={(event: { target: { value: string } }) => {
                                const value = event.target.value;
                                setFilterState(value)
                            }}
                            value={filterState}
                            style={{height: "2rem", border: "none", backgroundColor: "white"}}
                        >
                            <MenuItem value={"all"}>
                                Todos
                            </MenuItem>
                            <MenuItem value={"registrado"}>
                                Registrado
                            </MenuItem>
                            <MenuItem value={"observado"}>
                                Observado
                            </MenuItem>
                            <MenuItem value={"firmado"}>
                                Firmado
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            }
            rangeControlProps={{
                startDate: startDate,
                endDate: endDate,
                setEndDate: setEndDate,
                setStartDate: setStartDate,
            }}
            cardComponent={{
                cardContent: (row) => {
                    return (
                        <CardContent style={{padding: "0 1rem 1rem 1rem"}}>
                            <Grid container direction="row" alignItems="center" justifyContent="space-between">
                                <Grid item xs>
                                    <Typography variant="subtitle2" color="text.primary" marginBottom=".2rem">
                                    {row.Empresa}
                                    </Typography>
                                </Grid>
                                <Grid item maxWidth="4rem" minWidth="2rem">
                                    <DownloadButtonDocument
                                        signButton={true}
                                        FirmaTop={row.FirmaTop}
                                        FirmaLeft={row.FirmaLeft}
                                        FirmaPagePosition={row.FirmaPagina}
                                        NroFs={row.NroFS}
                                        FirmadoFecha={row.FirmadoFecha} 
                                        IdDocument={row.NroIdentificadorContrato}
                                        requestId={CONTRACT_DOCUMENT_SIGNATURE_REQUEST}
                                        signDisabled={row.FirmadoRespuesta ? true : false}
                                        isContract={true}
                                        
                                    />
                                </Grid>
                            </Grid>
                            {/* <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem">
                                {row.Empresa} 
                            </Typography> */}
                            
                            <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem">
                                Número contrato: {" "} {row.NumeroContrato} 
                            </Typography>
                            <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem">
                                Tipo contrato: {" "} {row.TipoContrato} 
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Oficina: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Area}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Estado: {" "}
                                <Typography variant="body2" component="span">
                                    {row.EstadoAceptacion}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha Inicio: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FechaInicio) as any}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha Fin: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FechaFin) as any}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Días finalizar: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.DiasVencimiento) as any}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha Envío: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FechaEnviadoPortal) as any}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha Firma: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FirmadoFecha) as any}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Observación: {" "}
                                <Typography variant="body2" component="span">
                                    <IconButton
                                        size="small"
                                        onClick={() => {
                                            setObservation(row.FirmadoRespuesta || "")
                                            setContractToObservate(row)
                                        }}
                                    >
                                        <EditNoteIcon fontSize="small" />
                                    </IconButton>
                                </Typography>
                                <Grid
                                    container 
                                    justifyContent="space-between" 
                                    direction="row"
                                    style={{minWidth: row.FirmadoRespuesta ? "11rem" : "7rem"}}
                                    component="span"
                                >
                                    <Grid 
                                        item 
                                        component="span"
                                        style={{
                                            width: row.FirmadoRespuesta ? "9rem" : "3rem", 
                                            // whiteSpace: "nowrap", 
                                            textOverflow: "ellipsis",
                                            overflow: "hidden",
                                            lineClamp: "2",


                                            display: "-webkit-box",
                                            WebkitLineClamp: 3,
                                            WebkitBoxOrient: "vertical",


                                        }}>
                                        {row.FirmadoRespuesta}
                                    </Grid>
                                </Grid>
                            </Typography>
                            
                        </CardContent>
                    );
                },
                numberOfCards: props?.numberOfCards,
                changeViewOptionHidden: props?.changeViewOptionHidden,
            }}
            tableOptionsBar={{
                useDrawer: true,
            }}
            hiddenBottomPaginator={props?.hiddenBottomPaginator}
        />
        <Dialog
            open={contractToObservate !== undefined}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
        >
            <DialogTitle
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Observar contrato
            </DialogTitle>
            <DialogContent style={{width: "100%"}}>
                <Grid container direction="column" style={{marginTop: "1.5rem", width: "100%"}}>
                    <Grid item>
                        <label 
                            style={{
                                color: "#666",
                                fontFamily: "Roboto",
                                fontSize: ".875rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "normal",
                            }}
                        >
                            Observación:
                        </label>
                    </Grid>
                    <Grid item width={"100%"}>
                        <TextField
                            style={{
                                width: "100%",
                                borderRadius: "0.25rem",
                                height: "auto !important",
                            }}
                            value={observation}
                            onChange={(event: any) => setObservation(event.target.value)}
                            fullWidth
                            rows={3}
                            hiddenLabel
                            variant="outlined"
                            multiline={true}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem"}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => {
                                setObservation("");
                                setContractToObservate(undefined);
                            }}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button 
                            variant="contained" 
                            style={{width: "8rem"}}
                            disabled={observation === ""}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={async () =>{
                                if (!companyselected?.Token || !observation) {
                                    return;
                                }
                                await setContractObservation(
                                    contractToObservate.NroIdentificadorContrato,
                                    observation,
                                )
                                dispatch(setContractObservationResult({
                                    NroIdentificadorContrato: contractToObservate.NroIdentificadorContrato,
                                    observation,
                                }))
                                setObservationResult({success: true, msg: "Observación agregada."})
                                setContractToObservate(undefined);
                            }}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
        {!!observationResult && <MySnackbar 
            msg={observationResult?.msg || ""}
            onClose={() => setObservationResult(null)}
            severity={observationResult?.success ? "success" : "error"}
            open={!!observationResult}
        />}
        </>
    )
}

export default TableContracts;